'use strict';

angular.module('myConsultApp')
	  .directive('fixfindpatientui', function ($cookieStore, $location, $routeParams, $rootScope, $timeout) {
	    return {
			restrict: 'A',
			link:function(scope,elem,attrs){

				//functions to adjust properly boxes size on Pet Dashboard
				function adjustTileBoxes(){
					/* Reset alignment, wheter to recalculate it or to display in single column */
					$( '.overview-score-box .tile_main_button' ).css("position", "inherit");
					$( '.overview-score-box .tile_main_button' ).css("top",'');
					if($( window ).width() > 780){

						/* Set the height of every tile to the same level */
						var taller = 0;
                        console.log($('.overview-score-box .body').length);

						$( '.overview-score-box .body' ).each(function(){
							var thisHeight = $(this).height();
							if(thisHeight > taller)
								taller = thisHeight;
                            console.log('taller: ' + taller);
						});
						if(taller != 0) {
							$( '.overview-score-box .body').height(taller);
                            console.log('height: ' + $( '.overview-score-box .body').height());
						}

                        var btnTaller = 0;
						/* ALIGN THE BUTTONS TO THE SAME LEVEL */
						/* Get the lowest button position */
						$( '.overview-score-box .tile_main_button' ).each(function(){
							var thisOffset = $(this).position().top;
							if(thisOffset > btnTaller)
								btnTaller = thisOffset;
                            console.log('offset: ' + btnTaller);
						});
						/* Nivelate */
						$( '.overview-score-box .tile_main_button' ).each(function(){
							var _this = $(this);
							var thisOffset = _this.position().top;
							if((btnTaller - thisOffset) > 0) {
								var diff = (btnTaller - thisOffset) + "px";
								_this.css("position", "relative");
								_this.css("top", diff);
							}
						});

					}
				}

				angular.element(window).resize(function () {
					adjustTileBoxes();
				});
				//end functions to adjust properly boxes size on Pet Dashboard
			   $timeout(function(){
				 adjustTileBoxes();
			   },100);


			   $rootScope.$on('fix-findapatient-ui', function() {
				   //console.log('fix boxes');
				   adjustTileBoxes();
			   });

			}
    };
});